export function toCsv(rows, headers) {
  const headerKeys = headers.map(h => h.key);
  const headerLabels = headers.map(h => sanitize(String(h.label ?? h.key)));
  const dataLines = rows.map(row => headerKeys.map(k => sanitize(valueToCell(row[k]))).join(','));
  const csv = [headerLabels.join(','), ...dataLines].join('\n');
  // Add BOM for Excel UTF-8 compatibility
  return '\uFEFF' + csv;
}

function valueToCell(val) {
  if (val === null || val === undefined) return '';
  if (val instanceof Date) return val.toISOString();
  if (typeof val === 'object') return JSON.stringify(val);
  return String(val);
}

function sanitize(text) {
  // Escape quotes and wrap in quotes; normalize new lines
  const safe = text.replace(/"/g, '""').replace(/\r?\n|\r/g, ' ');
  return '"' + safe + '"';
}

export function downloadCsv(csvText, filename) {
  const blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function normalizeRange(fromStr, toStr) {
  const from = fromStr ? new Date(fromStr) : null;
  const to = toStr ? new Date(toStr) : null;
  if (from && !Number.isNaN(from.valueOf())) {
    from.setHours(0,0,0,0);
  }
  if (to && !Number.isNaN(to.valueOf())) {
    to.setHours(23,59,59,999);
  }
  return { from, to };
}
